<template>
  <el-dialog
    custom-class="upload-file-dialog"
    :title="title"
    :visible.sync="dialogVisible"
    width="750px"
    :before-close="handleClose"
    :append-to-body="appendBody"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <div class="upload-content">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          v-for="item in folderPath"
          :key="item.id"
          class="breadcrumb-item" 
        >
          <span class="folder-item">{{ item.name }}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div v-if="fileList.length" class="file-list">
        <div v-for="item in fileList" :key="item.id" class="file-item">
          <div class="file-name">{{ item.name }}</div>
          <div class="file-progress">
            <el-progress :percentage="item.percentage" :stroke-width="14" :text-inside="true" define-back-color="#CAFFE8"/>
          </div>
          <div class="file-status">{{ item.status | uploadStatus }}</div>
          <div class="file-handle">
            <el-button
              v-show="[2, 3].includes(item.status)"
              type="text"
              :icon="
                item.status === 2 ? 'el-icon-video-pause' : 'el-icon-video-play'
              "
              @click="handleStartOrStop(item)"
            />
            <el-button
              v-show="item.status !== 1"
              type="text"
              icon="el-icon-delete"
              @click="deleteFile(item)"
            />
          </div>
        </div>
      </div>
      <div v-else class="empty">
        <img
          src="../../../assets/images/upload.png"
          alt=""
        />
        <el-upload
          ref="upload"
          class="upload-demo"
          action="*"
          :accept="fileType"
          :on-change="getFolderList"
          :auto-upload="false"
          :show-file-list="false"
          :multiple="true"
        >
          <el-button
            slot="trigger"
            size="small"
            style="margin-top: 10px"
            >选取文件</el-button
          >
          <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
        </el-upload>
      </div>
      <el-upload
        v-if="fileList.length"
        ref="upload"
        class="upload-file-btn"
        action="*"
        :accept="fileType"
        :on-change="getFolderList"
        :auto-upload="false"
        :show-file-list="false"
        :multiple="true"
      >
        <el-button slot="trigger" size="small" type="primary"
          >选取文件</el-button
        >
      </el-upload>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose"
        >返 回</el-button
      >
      <el-button type="primary" size="small" @click="clickOver"
        >完 成</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { cosUploadFile } from "@saas/components/src/utils/cos-upload";
import { saveFile, getSign } from "@saas/service-api/src/material/index.js";
import axios from "axios";
export default {
  filters: {
    uploadStatus(val) {
      switch (val) {
        case 0:
          return "上传失败";
        case 1:
          return "上传成功";
        case 2:
          return "上传中";
        case 3:
          return "已暂停";
        case 4:
          return "同步中";
      }
    },
  },
  props: {
    title: {
      type: String,
      default: "文件上传",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    folderData: {
      type: Object,
      default: () => {},
    },
    folderPath: {
      type: Array,
      default: () => [],
    },
    saveId: {
      type: [Number, String],
      default: "",
    },
    // fileType: {
    //   type: String,
    //   default: '*'
    // },
    type: {
      default: 1,
      type: Number,
    },
    limit: {
      default: 1,
      type: Number,
    },
    appendBody: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      fileList: [],
    };
  },
  computed: {
    fileType() {
      if (this.type === 1) {
        return "video/*";
      } else if (this.type === 2) {
        return ".pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx";
      } else if (this.type === 3) {
        return ".jpg, .jpeg, .png, .gif, .bmp";
      } else {
        return "*";
      }
    },
    // pathLable() {
    //   console.log(this.folderPath)
    //   return this.folderPath.map(item => item.name).join(' > ')
    // }
    isAdmin() {
      return this.$store.getters.app === "admin";
    },
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
        this.fileList = [];
      },
    },
  },
  methods: {
    handleClose() {
      if (this.fileList.some((item) => item.status === 2)) {
        this.$message.error("请等待全部文件上传完成");
        return;
      } else {
        this.$emit("close");
      }
    },
    deleteFile(file) {
      this.fileList = this.fileList.filter((item) => item.id !== file.id);
      file.cos.cancelTask(file.taskId);
      file.cancelSource.cancel();
    },
    handleStartOrStop(file) {
      if (file.status === 2) {
        file.cos.pauseTask(file.taskId);
        file.status = 3;
      } else {
        file.cos.restartTask(file.taskId);

        file.status = 2;
      }
    },
    // 判断文件名是否是图片
    isImage(name) {
      const reg = /(\.jpg|\.jpeg|\.png|\.gif|\.bmp)$/i;
      return reg.test(name);
    },
    // 判断文件名是否是视频
    isVideo(name) {
      const reg =
        /(\.mp4|\.avi|\.rmvb|\.wmv|\.flv|\.mov|\.mpg|\.mpeg|\.rm|\.asf|\.3gp|\.mkv|\.3g2|\.h264|\.m4v|\.mj2|\.ogg|\.ogv|\.qt|\.vob|\.webm|\.f4v)$/i;
      return reg.test(name);
    },
    // 判断文件名是否是文档
    isDoc(name) {
      const reg = /(\.pdf|\.doc|\.docx|\.ppt|\.pptx|\.xls|\.xlsx)$/i;
      return reg.test(name);
    },
    // 判断文件大小是否小于某值（MB）
    isLtSize(size, targetSize) {
      return size / 1024 / 1024 < targetSize;
    },
    getFolderList(file, fileList) {
      if (file.name.length > 100) {
        this.$message.error("文件名不能超过100个字符");
        return;
      }
      if (this.type === 1 && !this.isVideo(file.name)) {
        this.$message.error("请上传视频文件");
        return;
      } else if (this.type === 1 && !this.isLtSize(file.size, 1024 * 4)) {
        this.$message.error("请上传小于4G的视频文件");
        return;
      } else if (this.type === 2 && !this.isDoc(file.name)) {
        this.$message.error(`请上传${this.fileType}格式文档`);
        return;
      } else if (this.type === 2 && !this.isLtSize(file.size, 100)) {
        this.$message.error("请上传小于100MB的文件");
        return;
      } else if (this.type === 3 && !this.isImage(file.name)) {
        this.$message.error(`请上传${this.fileType}格式图片`);
        return;
      } else if (this.type === 3 && !this.isLtSize(file.size, 32)) {
        this.$message.error("请上传小于32MB的图片");
        return;
      }
      const fileData = {
        status: 2,
        name: file.name,
        raw: file.raw,
        id: file.uid,
        percentage: 0,
        taskId: "",
        cos: null,
      };
      const fn = getSign;
      fn({
        fileName: file.name,
        materialType: this.cosUploadFile,
      }).then((res) => {
        if (res.code === 1) {
          fileData.cos = cosUploadFile(
            {
              file: file.raw,
              fileName: file.name,
              type: this.type,
            },
            {
              ...res.data,
            },
            {
              onTaskReady: (taskId) => {
                fileData.taskId = taskId;
              },
              onProgress: (progerssData) => {
                const { percent } = progerssData;
                const currentPercentage = fileData.percentage;
                if (fileData.percentage > 0 && percent === 0) {
                  fileData.percentage = currentPercentage;
                } else {
                  fileData.percentage = parseFloat(
                    (progerssData.percent * 100).toFixed(2)
                  );
                }
              },
              onFileFinish: (err, data, options) => {
                if (data && data.statusCode === 200) {
                  fileData.status = 4;
                  fileData.cancelSource = axios.CancelToken.source();
                  const fn = saveFile;
                  fn(
                    {
                      id: 0,
                      material_name: file.name,
                      material_type: this.type,
                      pid: this.saveId
                        ? this.saveId
                        : this.folderPath[this.folderPath.length - 1]?.id || 0,
                      url: data.Location.startsWith("https://")
                        ? data.Location
                        : "https://" + data.Location,
                    },
                    {
                      cancelToken: fileData.cancelSource.token,
                    }
                  ).then((res) => {
                    if (res.code === 1) {
                      fileData.status = 1;
                      fileData.url = res.data.url;
                      fileData.name =
                        res.data.material_name + res.data.file_ext;
                      fileData.id = res.data.id;
                    } else {
                      fileData.status = 0;
                    }
                  });
                } else {
                  fileData.status = 0;
                  console.log(err);
                }
              },
            }
          );
        }
      });
      this.fileList.push(fileData);
    },
    clickOver() {
      if (
        this.fileList.some((item) => item.status === 2 || item.status === 4)
      ) {
        this.$message.error("请等待全部文件上传完成");
        return;
      } else {
        const arr = this.fileList.filter((item) => item.status === 1);
        this.$emit("success", arr);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper ::v-deep {
  .el-dialog {
    background-color: #F3F5F7;
    height: 540px;
  }
  .el-dialog__header {
    padding: 20px 24px;
    font-weight: 500;
    font-size: 16px;
    color: #0D1400;
    line-height: 22px;
  }
  .el-dialog__body {
    padding: 0 24px;
    height: 420px;
  }
  .el-breadcrumb {
    line-height: normal;
  }
}
.empty {
  height: 90%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    width: 200px;
  }
  p {
    margin-top: 10px;
    color: rgba(0, 0, 0, 0.45);
  }
  .el-button {
    height: 30px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #EFEFEF;
    width: 90px;
    font-weight: 600;
    font-size: 14px;
    color: #00C89D;
    padding: 0;
  }
}
.upload-content {
  overflow: hidden;
  width: 702px;
  height: 420px;
  background: #F9FAFB;
  border-radius: 12px;
  border: 1px solid #E1E2E5;
  background-color: #F9FAFB;
  padding: 20px;
  display: flex;
  flex-direction: column;
  .file-list {
    font-weight: 400;
    font-size: 14px;
    color: #0D1400;
    line-height: 20px;
    flex: 1;
    overflow-y: scroll;
    .file-item {
      height: 20px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .file-name {
        width: 336px;
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
        font-size: 14px;
        color: var(--el-text-color-primary);
      }
      .file-progress {
        width: 110px;
        margin-left: 75px;
        ::v-deep {
          .el-progress-bar__inner {
            background: linear-gradient( 90deg, #00EB81 0%, #00C89D 100%);
          }
        }
      }
      .file-status {
        margin-left: 10px;
        width: 100px;
        color: #515350;
      }
      .file-handle {
        width: 50px;
        margin: 0 10px;
      }
    }
  }
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  & > .el-button {
    margin-left: 20px;
  }
}
.el-button--default {
    height: 30px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #EFEFEF;
    min-width: 80px;
  }
  .el-button--primary {
    height: 30px;
    background: linear-gradient( 132deg, #00EB81 0%, #00C89D 100%);
    border-radius: 8px;
    min-width: 80px;
    border: none;
  }
.upload-file-btn {
  text-align: center;
  margin-top: 10px;
  
}
</style>
